export default __webpack_public_path__ + "static/media/3f86efd3608da6e5c686da20525b64e1.png";